




















































































































































































































/* eslint-disable no-unused-vars */
import BaseForm from '@/views/BaseForm';
import { Component } from 'vue-property-decorator';
import DeleteConfirm from '@/components/DeleteConfirm.vue';
import EditMachine from '@/components/childWindow/EditMachine.vue';
import { AxiosResponse } from 'axios';
import { groupMdl } from '@/models/groupMdl';
import { machinelistMdl, machinelistCastMdl } from '@/models/machineMdl';
/* eslint-enable no-unused-vars */

@Component({
    name: 'machine_list',
    components: { DeleteConfirm, EditMachine },
    head: {
        title: {
            inner: '機器一覧',
            separator: '-',
            complement: 'Battery-Surveillance',
        },
    },
})
export default class machine_list extends BaseForm {
    // ヘッダー情報
    private machineDataHeader: any = [
        { text: '機器管理番号', align: 'center', value: 'control_number', width: 170 },

        { text: '商品コード', align: 'center', value: 'product_code', filterable: false, width: 150 },
        { text: '商品名', align: 'center', value: 'product_name', filterable: false, width: 270 },
        { text: 'ロット番号', align: 'center', value: 'lot_number', filterable: false, width: 200 },
        { text: '事業所コード', align: 'center', value: 'office_code', filterable: false, width: 150 },
        { text: '事業所名', align: 'center', value: 'office_name', filterable: false, width: 150 },
        {
            text: '出庫先名',
            align: 'center',
            value: 'machine_name',
            filterable: false,
            width: 400,
        },
        {
            text: '出庫現場名',
            align: 'center',
            value: 'site_name',
            filterable: false,
            width: 400,
        },
        { text: 'バッテリ電圧', align: 'center', value: 'battery_level', filterable: false, width: 150 },
        { text: '電波強度', align: 'center', value: 'signalstrength', filterable: false, width: 100 },
        {
            text: 'しきい値(限界)',
            align: 'center',
            value: 'threshold_low',
            filterable: false,
            width: 160,
        },
        {
            text: 'しきい値(注意)',
            align: 'center',
            value: 'threshold_high',
            filterable: false,
            width: 160,
        },
        { text: '状態', align: 'center', value: 'state', filterable: false, width: 100 },
        { text: '貸出', align: 'center', value: 'lending_flg', filterable: false, width: 100 },
        { text: '移動検出', align: 'center', value: 'moving_flg', filterable: false, width: 100 },
        // { text: '通知間隔(分)', align: 'center', value: 'notification_interval', filterable: false, width: 120 },
        { text: '緯度', align: 'center', value: 'latitude', filterable: false, width: 120 },
        { text: '経度', align: 'center', value: 'longitude', filterable: false, width: 120 },
        { text: '備考', align: 'center', value: 'remark', filterable: false, width: 500 },
    ];
    private notificationItem: any = [10, 20, 30, 40, 50, 60];
    private machinDataList: machinelistMdl[] = []; // グループに登録済み機器一覧
    private cronMachinDataList: machinelistMdl[] = []; // 変更検知用モデルコピー
    private itemsPerPage: number = 50; // 1ページに表示するアイテム数
    private selectGroup: number = 0; // 選択されたグループID
    private searchMachine: string = ''; // 機器データ検索用
    private fileType: any = ['application/vnd.ms-excel', 'text/csv'];
    private error: string = '';
    private csvFile: any = {};
    private deleteConfirmFlg: boolean = false; // 削除確認ダイアログ
    private deleteMachineId: number = 0; // 削除する機器ID
    private editMachineFlg: boolean = false; // グループ編集ダイアログ

    created() {
        if (this.authority > 2) {
            this.machineDataHeader.unshift({ text: '会社名', align: 'center', value: 'corp_name', width: 250 });
        }
        if (this.authority >= 3) {
            this.machineDataHeader.push({
                text: 'STB MAC',
                align: 'center',
                value: 'stb_mac',
                filterable: false,
                width: 200,
            });
        }
        this.machineDataHeader.push({
            text: '最終更新日時',
            align: 'center',
            value: 'upd_date',
            filterable: false,
            width: 200,
        });
        if (this.authority >= 2) {
            this.machineDataHeader.push({
                text: '削除',
                align: 'center',
                value: 'delete',
                sortable: false,
                width: 100,
            });
        }
        this.getMachineList();
    }

    // 状態（色を取得）
    private getState(v: any) {
        let rtnClass: string = '';
        // 機器のしきい値と通信時間によって色を変える
        let nowtime = new Date();
        let datatime = new Date(v.acquisition_time);
        let diff = nowtime.getTime() - datatime.getTime();
        let diffminute = diff / (60 * 1000);
        if (diffminute > 60) {
            rtnClass = 'gray';
        } else {
            if (Number(v.battery_level) < Number(v.threshold_low)) {
                rtnClass = 'red';
            } else if (
                Number(v.battery_level) >= Number(v.threshold_low) &&
                Number(v.battery_level) < Number(v.threshold_high)
            ) {
                rtnClass = 'yellow';
            } else {
                rtnClass = 'green';
            }
        }

        return rtnClass;
    }
    private getLending(v: any) {
        if (v.lending_flg == 0) {
            return '✕';
        } else {
            return '〇';
        }
    }

    private async onClickConfirm() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let params: any = [];
            for (let i = 0; i < this.cronMachinDataList.length; i++) {
                if (!this.objectEquals(this.cronMachinDataList[i], this.machinDataList[i])) {
                    params.push(this.machinDataList[i]);
                }
            }
            const resp: AxiosResponse<any> = await this.$http.post('machine_edit.php', params, {
                headers: { token: this.token },
            });
            let errorMsg: string = '';
            switch (resp.data.result) {
                case 'SUCCESS':
                    // Loading画面を非表示にする
                    this.$store.dispatch('common/setLoadingStateAc', false);
                    this.getMachineList();
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    // this.validationErrors = resp.data.errors;
                    for (let k of Object.keys(resp.data.errors)) {
                        errorMsg += resp.data.errors[k] + '\n';
                    }
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: errorMsg,
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: '機器登録失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: '機器登録失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    private async getMachineList() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            const resp: AxiosResponse<any> = await this.$http.post('machine_list.php', 1, {
                headers: { token: this.token },
            });
            switch (resp.data.result) {
                case 'SUCCESS':
                case 'DATA_NOTFOUND_ERROR':
                    this.machinDataList = resp.data.items.map(function(v: any) {
                        return new machinelistMdl(machinelistMdl.toJsonDataOnModel(new machinelistCastMdl(v)));
                    });

                    this.cronMachinDataList = [];
                    // 変更検知用に取得データをコピーする
                    this.machinDataList.forEach((v: machinelistMdl) =>
                        this.cronMachinDataList.push(Object.assign({}, v))
                    );
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ取得失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ取得失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    private objectEquals(a: any, b: any) {
        if (a === b) {
            // 同一インスタンスならtrueを返す
            return true;
        }

        // 比較対象双方のキー配列を取得する（順番保証のためソートをかける）
        const aKeys = Object.keys(a).sort();
        const bKeys = Object.keys(b).sort();

        // 比較対象同士のキー配列を比較する
        if (aKeys.toString() !== bKeys.toString()) {
            // キーが違う場合はfalse
            return false;
        }

        // 値をすべて調べる。
        const wrongIndex = aKeys.findIndex(function(value) {
            // 注意！これは等価演算子で正常に比較できるもののみを対象としています。
            // つまり、ネストされたObjectやArrayなどには対応していないことに注意してください。
            return a[value] !== b[value];
        });

        // 合致しないvalueがなければ、trueを返す。
        return wrongIndex === -1;
    }

    // 選択ファイル変更時処理
    private changeFile(e: any) {
        if (e) {
            if (this.validation(e)) {
                this.csvFile = e;
            } else {
                this.csvFile = {};
            }
        } else {
            this.csvFile = {};
        }
    }
    // アップロードファイルバリデーション
    private validation(file: File) {
        if (this.fileType.indexOf(file.type) == -1) {
            this.error = 'CSVファイルのみインポート可能です。';
            return false;
        }
        if (file.size > 10000000) {
            this.error = '10MB未満のデータのみインポート可能です。';
            return false;
        }
        this.error = '';
        return true;
    }
    // CSVインポート実行処理
    private async onClickImportMachine() {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);
            let data = new FormData();
            data.append('form_file', this.csvFile, 'tmp_name');
            const resp: AxiosResponse<any> = await this.$http.post('machine_csv_import.php', data, {
                headers: { token: this.token, 'content-type': 'multipart/form-data' },
            });
            let errorMsg: string = '';
            switch (resp.data.result) {
                case 'SUCCESS':
                    // Loading画面を非表示にする
                    this.$store.dispatch('common/setLoadingStateAc', false);
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'csv取り込み成功',
                        return_flg: false,
                    });
                    this.getMachineList();
                    break;
                case 'VALIDATION_ERROR':
                    // バリデーションエラーメッセージをセット
                    // this.validationErrors = resp.data.errors;
                    for (let k of Object.keys(resp.data.errors)) {
                        errorMsg += resp.data.errors[k] + '\n';
                    }
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: errorMsg,
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'SAVE_FAILED_ERROR':
                    // バリデーションエラーメッセージをセット
                    // this.validationErrors = resp.data.errors;
                    errorMsg = resp.data.errors;
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: errorMsg,
                        return_flg: false,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: '機器登録失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: '機器登録失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    // 機器削除
    private onClickDelete(item: machinelistMdl) {
        this.deleteConfirmFlg = true;
        this.deleteMachineId = item.machine_id;
    }
    // 削除確認ダイアログクローズ
    private closeDeleteDialog(value: boolean) {
        this.deleteConfirmFlg = false;
        if (value) {
            this.machineDelete(this.deleteMachineId);
        }
    }
    private async machineDelete(machine_id: number) {
        try {
            // Loading画面を表示する
            this.$store.dispatch('common/setLoadingStateAc', true);

            let params: any = { machine_id: machine_id };
            const resp: AxiosResponse<any> = await this.$http.post('machine_delete.php', params, {
                headers: { token: this.token },
            });

            switch (resp.data.result) {
                case 'SUCCESS':
                    // データの再取得
                    await this.getMachineList();
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'success',
                        timeout: 5000,
                        message: 'データ削除完了',
                        return_flg: false,
                    });
                    break;
                case 'SESSION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 3000,
                        message: 'ログイン期限が終了しました。再度ログインして下さい。',
                        return_flg: true,
                    });
                    break;
                case 'AUTHORITY_ERROR':
                case 'SAVE_FAILED_ERROR':
                case 'DBCONNECTION_ERROR':
                    this.$store.dispatch('common/setAlertParamsAc', {
                        is_display: true,
                        type: 'error',
                        timeout: 5000,
                        message: 'データ削除失敗',
                        return_flg: false,
                    });
                    break;
            }
        } catch (error) {
            this.$store.dispatch('common/setAlertParamsAc', {
                is_display: true,
                type: 'error',
                timeout: 5000,
                message: 'データ削除失敗',
                return_flg: false,
            });
        } finally {
            // Loading画面を非表示にする
            this.$store.dispatch('common/setLoadingStateAc', false);
        }
    }
    // 機器追加
    private onClickEdit() {
        this.editMachineFlg = true;
    }
    // グループ編集ダイアログクローズ
    private closeEditMachineDialog(value: boolean) {
        this.editMachineFlg = false;
        if (value) {
            // 機器データ取得
            this.getMachineList();
        }
    }
}
